module.exports = __webpack_public_path__ + "assets/img/label1.643c9585.svg";